import { Button, Dialog, DialogActions, DialogContent, DialogTitle, Stack, Typography } from "@mui/material";

export default function ResourcesProductionInfoDialog({ open, onClose }) {
  return (
    <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
      <DialogTitle>How ResourceNAV structures resources & production</DialogTitle>
      <DialogContent>
        <Stack spacing={1.25}>
          <Typography variant="body2" color="text.secondary">
            "Assets" are a general term for a mining company’s projects, properties, and complexes.
            Within each asset, companies have mines and deposits, which ResourceNAV calls
            “Resources & Reserves.”
          </Typography>
          <Typography variant="body2" color="text.secondary">
            All data (Resource & Reserve Estimates, Production Reporting, and Forecasts) is
            captured at the mine & deposit level and then rolled up to the Asset and Company level to
            produce the numbers seen in the Assets, Operations and Forecast tabs here.
          </Typography>
          <Typography variant="caption" color="text.secondary" fontWeight={700}>
            Definitions
          </Typography>
          <Stack spacing={0.6}>
            <Typography variant="body2" color="text.secondary">
              • <b>Assets:</b> projects/properties/complexes owned or operated by the company
            </Typography>
            <Typography variant="body2" color="text.secondary">
              • <b>Resources & Reserves:</b> mines and deposits within each asset
            </Typography>
            <Typography variant="body2" color="text.secondary">
              • <b>Resource & Reserve Estimates:</b> point-in-time metal amounts by classification (Proven,
              Probable, Measured, Indicated, Inferred). Resource estimates are <b>inclusive</b> of reserve estimates. 
            </Typography>
            <Typography variant="body2" color="text.secondary">
              • <b>Production Reporting:</b> reported metrics by period
            </Typography>
            <Typography variant="body2" color="text.secondary">
              • <b>Forecasts:</b> expected future production by period
            </Typography>
          </Stack>
          <Typography variant="body2" color="text.secondary" sx={{pt:2}}>
            <b>ResourceNAV</b> is currently working with companies to build out this asset database to
            create a rich dataset of resources, production and forecast metrics to use for enhanced display & screening
            purposes.
          </Typography>
          <Typography variant="body2" color="text.secondary">
            If you are a mining company, claim your company profile and enter in asset
            information to publish data on the platform.
          </Typography>
        </Stack>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>Close</Button>
      </DialogActions>
    </Dialog>
  );
}
